import axios from 'axios'
import Base64 from 'js-base64'
import Cookies from 'js-cookie'
import Router from '../../router'

let base = Base64.Base64
import { Message } from 'element-ui'
import qs from 'qs'

const noopPromise = {
  then: () => noopPromise,
  catch: () => noopPromise
};

// service.interceptors.response.use(
//     /**
//      * 1、通过在response里，自定义code来标示请求状态
//      * 2、如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
//      */
//     response => {
//         let code = response.data.code
//         // let code = code.toString().startsWith('6')
//         if (response.data.code)
//         if(resp.data.code === 402 || resp.data.code === 405 || resp.data.code === 406){
//             Message.error("登陆失效，请重新登陆！");
//             Cookies.remove("token");
//             setTimeout( () => {
//                 Router.push("/");
//             }, 2000)
//         }
//         return response
//     },
//     error => {
//         console.log('--res error--', error)
//         if (error.response) {
//             const status = error.response.status || null
//             // 处理http请求响应码
//             switch (status) {
//                 case 400:
//                     // 400 可能是请求数据格式错误
//                     Message({
//                         message: error.response.data.message,
//                         type: 'error',
//                         duration: 5 * 1000
//                     })
//                     break
//                 case 401:
//                     // 401 身份验证失败，常见于token过期
//                     MessageBox.confirm(i18n.t('request.error_401'), i18n.t('request.error_title'), {
//                         confirmButtonText: i18n.t('request.confirm'),
//                         cancelButtonText: i18n.t('request.cancel'),
//                         type: 'warning'
//                     }).then(() => {
//                         // 注销账号
//                         store.dispatch('LogOut').then(() => {
//                             // 为了重新实例化vue-router对象 避免bug
//                             location.reload()
//                         })
//                     })
//                     break
//                 case 404:
//                     // 404 找不到资源。
//                     if (error.response.data) {
//                         Message({
//                             message: error.response.data.message,
//                             type: 'error',
//                             duration: 5 * 1000
//                         })
//                     } else {
//                         // 如果服务端没返回message，则进行重定向！我认为要用replace，然后给一个回到首页的入口！
//                         router.replace('/404')
//                     }
//                     break
//                 case 403:
//                     // 没有权限访问
//                     Message({
//                         message: i18n.t('request.error_403'),
//                         type: 'error',
//                         duration: 5 * 1000
//                     })
//                     break
//                 default:
//                     // 其他响应码
//                     Message({
//                         message: 'Request error',
//                         type: 'error',
//                         duration: 5 * 1000
//                     })
//                     break
//             }
//         } else {
//             Message({
//                 message: 'Request error',
//                 type: 'error',
//                 duration: 5 * 1000
//             })
//         }
//         return Promise.reject('error')
//     })

// axios创建一个实例

const instance = axios.create({
  // baseURL: "https://ppapp.666yiyao.com",
});
//添加请求拦截器
// instance.interceptors.request.use(function (config) {

//   console.log("请求内容", config);
//   return config;
// }, function (error) {
//   //对请求错误做些什么
//   return Promise.reject(error)
// });

export default {
  formPost(url, data) {
    return new Promise((resolve, reject) => {
      let fileContent = '';
      let fileName = '';
      let formData = new FormData();
      for (let i in data) {
        if (i == 'fileContent') {
          fileContent = data[i];
        } else if (i == 'fileName') {
          fileName = data[i];
        } else {
          formData.append(i, data[i]);
        }
      }
      if (fileContent && fileName) { //若有file文件
        formData.append('file', fileContent, fileName);
      }
      formData.append('companyId', 20116);
      const token = Cookies.get('token')
      let realHeader = {
        'Authorization': token ? 'Bearer ' + token : '',
        'Content-Type': 'application/json; charset=UTF-8',
      };
      axios.post('/abb/api/jsonws' + url, formData, { contentType: false, processData: false, headers: realHeader })
        .then(res => {
          resolve(res)
        }, err => {
          Message.error("网络似乎出小差了，请查看网络稍后重试！")
          reject(err)
        })
    })
  },
  new_formPost(url, data) {
    return new Promise((resolve, reject) => {
      let fileContent = '';
      let fileName = '';
      let formData = new FormData();
      for (let i in data) {
        if (i == 'fileContent') {
          fileContent = data[i];
        } else if (i == 'fileName') {
          fileName = data[i];
        } else {
          formData.append(i, data[i]);
        }
      }
      if (fileContent && fileName) { //若有file文件
        formData.append('file', fileContent, fileName);
      }
      formData.append('companyId', 20116);
      const token = Cookies.get('token')
      let realHeader = {
        'Authorization': token ? 'Bearer ' + token : "",
        'Content-Type': 'application/json; charset=UTF-8',
      };
      axios.post('/abc' + url, formData, { contentType: false, processData: false, headers: realHeader })
        .then(res => {
          resolve(res)
        }, err => {
          Message.error("网络似乎出小差了，请查看网络稍后重试！")
          reject(err)
        })
    })
  },
  get(url, data) {
    return new Promise((resolve, reject) => {
      console.log(url, data)
      axios.get(url, data).then(res => {
        resolve(res)
      }, err => {
        Message.error("网络似乎出小差了，请查看网络稍后重试！")
        reject(err)
      })
    })
  },
  post(url, data) {
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(data)).then(res => {
        resolve(res)
      })
        .catch(err => {
          console.log(err)
          if (err.data.error_msg) {
            Message.error(err.data.error_msg)
          } else {
            Message.error("网络似乎出小差了，请查看网络稍后重试！")
          }
          reject(err)
        })
    })
  },



  // LSYuan 
  // OSS 文件上传
  OSSUpload(url, data) {
    return new Promise((resolve, reject) => {
    //   axios.post(url, data, {headers: {'Content-Type': 'multipart/form-data'}})
      axios.post(url, data)
      .then(res => {
        resolve(res)
        // if (res.data.messageCode == "200") {
        //   resolve(res)
        // }else{
        //   reject(res)
        //   Message.error(res.data.messageInfo);
        // }
      })
      .catch(err => {
        Message.error("网络似乎出小差了，请查看网络稍后重试！")
        reject(err)
      })
    })
  },
  // post 文件上传
  postFile(url, data) {
    return new Promise((resolve, reject) => {
      const token = Cookies.get('token')
      instance.post(url, data, token && token !== undefined && token != 'undefined' ? {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + token,
        }
      } : {}).then(res => {
        if (res.data.messageCode == "200") {
          resolve(res)
        }else{
          reject(res)
          Message.error(res.data.messageInfo);
        }
      })
      .catch(err => {
        Message.error("网络似乎出小差了，请查看网络稍后重试！")
        reject(err)
      })
    })
  },
  // post+json 
  postNormal(url, data) {
    return new Promise((resolve, reject) => {
      const token = Cookies.get('token')
      instance.post(url, data, token && token !== undefined && token != 'undefined' ? {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'Authorization': 'Bearer ' + token,
        }
      } : {}).then(res => {
        if (res.data.messageCode == "200") {
          resolve(res)
        }else{
          reject(res)
          Message.error(res.data.messageInfo);
        }
      })
      .catch(err => {
        Message.error("网络似乎出小差了，请查看网络稍后重试！")
        reject(err)
      })
    })
  },
  // delete+json 
  deleteNormal(url, params) {
    return new Promise((resolve, reject) => {
      const token = Cookies.get('token')
      instance.delete(url, token && token !== undefined && token != 'undefined' ? {
        data: params,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'Authorization': 'Bearer ' + token,
        }
      } : {}).then(res => {
        if (res.data.messageCode == "200") {
          resolve(res)
        }else{
          reject(res)
          Message.error(res.data.messageInfo);
        }
      })
      .catch(err => {
        Message.error("网络似乎出小差了，请查看网络稍后重试！")
        reject(err)
      })
    })
  },
  // put
  putNormal(url, data) {
    return new Promise((resolve, reject) => {
      const token = Cookies.get('token')
      instance.put(url, data, token && token !== undefined && token != 'undefined' ? {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'Authorization': 'Bearer ' + token,
        }
      } : {}).then(res => {
        if (res.data.messageCode == "200") {
          resolve(res)
        }else{
          reject(res)
          Message.error(res.data.messageInfo);
        }
      })
      .catch(err => {
        Message.error("网络似乎出小差了，请查看网络稍后重试！")
        reject(err)
      })
    })
  },
  // get
  getNormal(url,data){
    return new Promise((resolve, reject) => {
      let str = url + "?";
      for (let i in data) {
        str += `${i}=${data[i]}&`
      }
      // console.log(str)
      let token = Cookies.get('token')
      // console.log("token", token);
      instance({
        method: "get",
        url: str,
        headers: token && token !== undefined && token != 'undefined' ? 
          {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': 'Bearer ' + token,
          }
        : {}
      }).then(res => {
        if (res.data.messageCode == "200") {
          resolve(res)
        }else{
          reject(res)
          Message.error(res.data.messageInfo);
        }
      }, err => {
        Message.error("网络似乎出小差了，请查看网络稍后重试！")
        reject(err)
      })
    })
  },




  newGet(url, data) {
    return new Promise((resolve, reject) => {
      let str = "/abc" + url + "?";
      console.log(str)
      for (let i in data) {
        str += `${i}=${data[i]}&`
      }
      console.log(str)
      const token = Cookies.get('token')
      axios.get(str, {}, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'Authorization': token ? 'Bearer ' + token : "",
        }
      }).then(res => {
        resolve(res)
      }, err => {
        Message.error("网络似乎出小差了，请查看网络稍后重试！")
        reject(err)
      })
    })
  },
  //基于json的post请求封装 liujixin 20201102
  async postJson(url, data, callback) {
    if (data && data.pageInfo) {
      data.pageInfo.isLoading = true;
    }
    return await new Promise((resolve, reject) => {
      // console.log("cookei实时", Cookies.get('token'))
      // console.log("cookei实时1", Cookies.get('token'))
      const token = Cookies.get('token')
      axios.post(url, data, token && token !== undefined && token != 'undefined' ? {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'Authorization': 'Bearer ' + token,
        }
      } : {}).then(resp => {
        console.log(url, resp)
        if (resp.data.code === 200) {
          if (data && data.pageInfo) {
            // data.pageInfo.totalCount = resp.data.pageInfo.totalCount;
            // data.pageInfo.pageCount = resp.data.pageInfo.pageCount;
            data.pageInfo.isLoading = false;
          }
          console.log("postJson请求返回结果为:", resp.data.mainData);
          resolve(resp.data.mainData);
        } else {
          let code = resp.data.code.toString().substring(0, 1);
          if (code === '4') {
            if (resp.data.code === 402 || resp.data.code === 405 || resp.data.code === 406) {
              Message.error("登陆失效，请重新登陆！");
              Cookies.remove("token");
              setTimeout(() => {
                Router.push("/");
              }, 2000)
            } else {
              Message.error(resp.data.message);
            }
          } else if (code == '5') {
            Message.error("调用后台接口未知异常");
          }
          if (data && data.pageInfo) {
            data.pageInfo.isLoading = false;
            console.log("data.pageInfo.isLoading", data.pageInfo.isLoading)
          }
          if (callback) {
            callback(resp.data);
          }
          // resolve(data);
          // resolve(null);
        }
      }).catch(err => {
        console.log("postJson请求出错:", err);
        if (data && data.pageInfo) {
          data.pageInfo.isLoading = false;
        }
        if (err.message) {
          Message.error("调用后台接口失败,错误信息为:" + err.message);
        } else {
          Message.error("调用后台接口出错！");
        }
        reject(err);
      })
    });
  },

  //基于json的get请求封装 liujixin 20201102
  getJson(url, data) {
    return new Promise((resolve, reject) => {
      // console.log(url, data)
      const token = Cookies.get('token');
      console.log("getJson", token);
      axios.get(url, {
        params: data,
        headers: token && token !== undefined && token != 'undefined' ?
          {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': 'Bearer ' + token,
          } : {}
      }
      ).then(resp => {
        if (resp.data.code === 200) {
          resolve(resp.data.mainData);
        } else {
          Message("调用后台接口失败,异常信息为:" + resp.data.message);
        }
        resolve(resp)
      }, err => {
        if (err.message) {
          console.log("getJson请求出错:", err);
        } else {
          console.log("getJson请求出错");
        }
        Message.error("网络似乎出小差了，请查看网络稍后重试！")
        reject(err)
      })
    });
  },

  // 不需要token的post请求
  async postJsonWithoutToken(url, data, callback) {
    if (data && data.pageInfo) {
      data.pageInfo.isLoading = true;
    }
    return await new Promise((resolve, reject) => {
      axios.post(url, data, {}).then(resp => {
        console.log(url, resp)
        if (resp.data.code >= 200 && resp.data.code < 300) {
          if (data && data.pageInfo) {
            // data.pageInfo.totalCount = resp.data.pageInfo.totalCount;
            // data.pageInfo.pageCount = resp.data.pageInfo.pageCount;
            data.pageInfo.isLoading = false;
          }
          console.log("postJson请求返回结果为:", resp.data.mainData);
          resolve(resp.data.mainData);
        } else {
          let code = resp.data.code.toString().substring(0, 1);
          if (code === '4') {
            if (resp.data.code === 402 || resp.data.code === 405 || resp.data.code === 406) {
              Message.error("登陆失效，请重新登陆！");
              Cookies.remove("token");
              setTimeout(() => {
                Router.push("/");
              }, 2000)
            } else {
              Message.error(resp.data.message);
            }
          } else if (code == '5') {
            Message.error("调用后台接口未知异常");
          }
          if (data && data.pageInfo) {
            data.pageInfo.isLoading = false;
            console.log("data.pageInfo.isLoading", data.pageInfo.isLoading)
          }
          if (callback) {
            callback(resp.data);
          }
          // resolve(data);
          // resolve(null);
        }
      }).catch(err => {
        console.log("postJson请求出错:", err);
        if (data && data.pageInfo) {
          data.pageInfo.isLoading = false;
        }
        if (err.message) {
          Message.error("调用后台接口失败,错误信息为:" + err.message);
        } else {
          Message.error("调用后台接口出错！");
        }
        reject(err);
      })
    });
  },

  // url 格式：/yiyaoapi/copd/check-info/latest/xxx/xxx
  // data 格式：/xxx/xxx
  getJson2(url, data) {
    return new Promise((resolve, reject) => {
      // console.log(url, data)
      const token = Cookies.get('token');
      console.log("getJson", token);
      axios.get(url + data, {
        headers: token && token !== undefined && token != 'undefined' ?
          {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': 'Bearer ' + token,
          } : {}
      }
      ).then(resp => {
        if (resp.data.code === 200) {
          resolve(resp.data.mainData);
        } else {
          Message("调用后台接口失败,异常信息为:" + resp.data.message);
        }
        resolve(resp)
      }, err => {
        Message.error("网络似乎出小差了，请查看网络稍后重试！")
        reject(err)
      })
    });
  },


  postWithParams(url, data) {
    return new Promise((resolve, reject) => {
      const token = Cookies.get("token");
      let headers = {};
      if (token && token !== undefined && token != "undefined")
        headers = {
          "Content-Type": "application/json; charset=UTF-8",
          Authorization: "Bearer " + token,
        };
      else headers = {};
      axios({ url, method: "POST", headers, params: data, })
        .then((res) => {
          if (res.data.code == 200) {
            resolve(res.data)
          } else {
            // Message.error("调用后台接口失败,异常信息为:" + res.data.message);
            resolve(res.data)
          }
        }).catch((err) => {
          Message.error("网络似乎出小差了，请查看网络稍后重试！")
          reject(err)
        });
    })
  },

}


// WEBPACK FOOTER //
// ./src/assets/js/fetchData.js